const landingTypesList = [
  '/',
  '/fullPrice',
  '/trial',
  '/intro',
  '/defb',
  '/trialb',
  '/introb',
  '/main',
  '/discountb',
  '/anim',
  '/trial-anim',
  '/intro-anim',
  '/map',
];

export default landingTypesList;
